import { ProductData } from "../model/types/productData";

export type SubscriptionChangeDirection = {
  isUpgrade: boolean;
  isDowngrade: boolean;
};

/**
 * Compares catalog prices to classify a plan change as upgrade, downgrade, or neither (same tier).
 */
export function getSubscriptionChangeDirection(
  current: ProductData | null | undefined,
  selected: ProductData | null | undefined
): SubscriptionChangeDirection {
  if (!current || !selected) {
    return { isUpgrade: false, isDowngrade: false };
  }
  const currentPrice = Number(current.price);
  const selectedPrice = Number(selected.price);
  return {
    isUpgrade: selectedPrice > currentPrice,
    isDowngrade: selectedPrice < currentPrice,
  };
}
